import { Link } from "react-router-dom";
import { Star, Phone } from "lucide-react";
import { Reveal, Eyebrow } from "./common";
import { COMPANY, REVIEWS } from "../data/site";

export function PageHero({ eyebrow, title, sub, image }) {
  return (
    <section className="relative" style={{ minHeight: "62vh" }}>
      <img
        src={image}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 hero-overlay" />
      <div className="relative container-x flex flex-col justify-center" style={{ minHeight: "62vh", paddingTop: "7rem", paddingBottom: "3rem" }}>
        <Reveal>
          <Eyebrow light>{eyebrow}</Eyebrow>
        </Reveal>
        <Reveal delay={100}>
          <h1
            className="display-title text-white mt-5 text-5xl md:text-7xl max-w-4xl"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </Reveal>
        {sub && (
          <Reveal delay={200}>
            <p className="mt-6 text-lg md:text-xl max-w-2xl" style={{ color: "rgba(255,255,255,0.82)" }}>
              {sub}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}

export function CTASection() {
  return (
    <section style={{ background: "var(--ink)" }} className="section" data-testid="cta-section">
      <div className="container-x text-center">
        <Reveal>
          <Eyebrow light>Parlons de votre projet</Eyebrow>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="display-title text-white mt-4 text-4xl md:text-5xl max-w-3xl mx-auto">
            Prêt à transformer la gestion de vos locations ?
          </h2>
        </Reveal>
        <Reveal delay={160}>
          <p className="mt-5 max-w-xl mx-auto" style={{ color: "rgba(255,255,255,0.7)" }}>
            Contactez-nous dès aujourd'hui pour un devis personnalisé et gratuit.
            Nous répondons sous 24h.
          </p>
        </Reveal>
        <Reveal delay={240}>
          <div className="mt-9 flex flex-wrap justify-center gap-4">
            <Link to="/contact" className="btn btn-primary" data-testid="cta-devis">
              Demander un devis gratuit
            </Link>
            <a href={`tel:${COMPANY.phoneIntl}`} className="btn btn-outline" data-testid="cta-phone">
              <Phone size={16} /> {COMPANY.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function Reviews() {
  return (
    <section className="section" style={{ background: "var(--cream)" }} data-testid="reviews-section">
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal><Eyebrow>Ils nous font confiance</Eyebrow></Reveal>
          <Reveal delay={80}>
            <h2 className="display-title mt-4 text-4xl md:text-5xl">
              Ce que disent nos clients
            </h2>
          </Reveal>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mt-14">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 100}>
              <div
                className="h-full p-8 flex flex-col"
                style={{ background: "#fff", border: "1px solid var(--line)" }}
              >
                <div className="flex gap-1" style={{ color: "var(--gold)" }}>
                  {[...Array(5)].map((_, k) => (
                    <Star key={k} size={16} fill="currentColor" />
                  ))}
                </div>
                <p className="mt-5 text-[0.95rem] leading-relaxed flex-1" style={{ color: "var(--ink)" }}>
                  {r.text}
                </p>
                <div className="mt-6 pt-5" style={{ borderTop: "1px solid var(--line)" }}>
                  <div className="font-display text-xl">{r.name}</div>
                  <div className="text-xs mt-1" style={{ color: "var(--muted)" }}>{r.date}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="text-center mt-10">
          <a href={COMPANY.reviewLink} target="_blank" rel="noreferrer" className="btn btn-outline-dark" data-testid="leave-review">
            Laisser un avis
          </a>
        </div>
      </div>
    </section>
  );
}
